<template>
  <div class="product-description-container">
    <div class="description-header">
      <div v-if="title" class="description-title">{{ title || 'Desciption' }}</div>
      <div class="description-actions-wrapper">
        <!-- <CrawlData @insert-sections="handleInsertSections" /> -->
        <div
          class="description-actions"
          :class="{ 'description-actions-disabled': !sections.length }"
          @click="sections.length && handleCopySections()"
        >
          <v-icon color="primary" size="16">mdi-content-copy</v-icon>
          <span>Copy Sections</span>
        </div>
        <div class="description-actions" @click="handlePasteSections">
          <v-icon color="primary" size="16">mdi-content-paste</v-icon>
          <span>Paste Sections</span>
        </div>
        <div
          v-if="behaviorCreateDescription.showSwitchCreateDescription"
          class="description-actions"
          @click="handleSwitchCreateDescription"
        >
          <v-icon color="primary" size="20">mdi-swap-horizontal</v-icon>
          <span>{{ behaviorCreateDescription.nameActionSwitch }}</span>
        </div>
      </div>
    </div>
    <div class="mb-5" v-if="behaviorCreateDescription.showCkEditor">
      <ckeditor :editor="editor" v-model="catalog[model]" :config="editorConfig" />
    </div>
    <!-- placeholder-add-new -->
    <div
      class="placeholder-add-new"
      @click="handleInsertNewSection()"
      v-if="behaviorCreateDescription.showPlaceholderAddNewSection"
    >
      <div class="placeholder-add-new-item">
        <v-icon color="primary" size="20">mdi-plus</v-icon>
        <span>Add Section</span>
      </div>
    </div>
    <!-- section-item -->
    <div ref="descriptionContainer">
      <div v-if="behaviorCreateDescription.showSectionItem" class="container-size">
        <div
          class="product-section-item"
          v-for="(section, index) in visibleSections"
          :key="index + '-' + section.id"
          :id="section.id"
        >
          <div class="section-item-actions">
            <div class="action-item" @click="handleViewSection(section)">
              <v-icon color="primary" size="19">mdi-expand-all</v-icon>
              <span>Expand</span>
            </div>
            <div class="action-item" @click="handleViewSectionEditor(section)">
              <v-icon color="primary" size="19">mdi-pencil</v-icon>
              <span>Edit</span>
            </div>
            <div class="action-item" @click="handleDeleteSection(section)">
              <v-icon color="error" size="20">mdi-delete</v-icon>
              <span>Delete</span>
            </div>
          </div>
          <div class="move-action">
            <div
              :class="index === 0 ? 'move-action-item-disabled' : 'move-action-item'"
              @click="handleMoveSection(section, 'up')"
            >
              <v-icon color="primary" size="20">mdi-arrow-up</v-icon>
            </div>
            <div
              :class="index === visibleSections.length - 1 ? 'move-action-item-disabled' : 'move-action-item'"
              @click="handleMoveSection(section, 'down')"
            >
              <v-icon color="primary" size="20">mdi-arrow-down</v-icon>
            </div>
          </div>
          <div class="insert-new-section-action">
            <div class="insert-new-section-action-item" @click="handleInsertNewSection(section, 'above')">
              <v-icon color="primary" size="20">mdi-plus</v-icon>
              <span>Add Section Above</span>
            </div>
            <div class="insert-new-section-action-item" @click="handleInsertNewSection(section, 'below')">
              <v-icon color="primary" size="20">mdi-plus</v-icon>
              <span>Add Section Below</span>
            </div>
          </div>
          <div v-html="section.html"></div>
        </div>
      </div>
    </div>

    <!-- Copy / Paste feedback -->
    <v-snackbar v-model="snackbar" :color="snackbarColor" top center timeout="2000">
      {{ snackbarMessage }}
    </v-snackbar>

    <!-- Template Modal -->
    <SelectSectionTemplate
      :open="showSectionTemplateModal"
      @select="handleSectionTemplateSelect"
      @close="handleCloseSectionTemplateModal"
    />
    <!-- View Section Modal -->
    <v-dialog v-model="viewExpandSection.showViewSection" fullscreen hide-overlay>
      <ViewSectionTemplate
        v-if="viewExpandSection.showViewSection"
        :open="viewExpandSection.showViewSection"
        :section="viewExpandSection.section"
        @close="viewExpandSection.showViewSection = false"
      />
    </v-dialog>

    <!-- View Section Editor Modal -->
    <CustomizeCard
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCustomizeCard"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FreestyleSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFreestyle"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ProductGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionProductGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SatelliteGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSatelliteGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <QuestionFaqSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionQuestionFaq"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <IconWithTextSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionIconWithText"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardWithSurvey
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardWithSurvey"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardDualImageSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardDualImg"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FindAnswerSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFindAnswer"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TextCarouselSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTextCarousel"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ProductReviewsSectionEditor
      v-if="
        viewSectionEditor.show &&
          (viewSectionEditor.section.type === sectionType.sectionProductReviews ||
            viewSectionEditor.section.type === sectionType.sectionProductReviews02 ||
            viewSectionEditor.section.type === sectionType.sectionProductReviews03 ||
            viewSectionEditor.section.type === sectionType.sectionProductReviews04 ||
            viewSectionEditor.section.type === sectionType.sectionProductReviews05 ||
            viewSectionEditor.section.type === sectionType.sectionProductReviews06 ||
            viewSectionEditor.section.type === sectionType.sectionGatorzReviews ||
            viewSectionEditor.section.type === sectionType.sectionSaintbrandReviews ||
            viewSectionEditor.section.type === sectionType.sectionLosaprilyReviews ||
            viewSectionEditor.section.type === sectionType.sectionFastvaluedealReviews)
      "
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <HeadingSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionHeading"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardSmokingSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardSmoking"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewGridKindLokalSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewGridKindLokal"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MarqueeWithTextSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarqueeBasicText"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardWithSurveyTextSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTextSurvey"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCompareTwoImageSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCompareTwoImg"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCompareYuriSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCompareYuri"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardTimelineYuriSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardTimelineYuri"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardSliderYuriSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardSliderYuri"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewSliderYuriSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewSliderYuri"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardStatisticsYuriSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardStatisticsYuri"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardWithTableCompareSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardWithTableCompare"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <BannerSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBannerSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <IconWithTextSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionIconWitTextSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SubscribeEmailSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSubscribeEmail"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardSonaSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardSona"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TinoGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTinoGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewInfiniteMarqueeSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewInfiniteMarquee"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <QuestionAndAnswerGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFaqGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <QuestionAndAnswerGrid02SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFaqGrid02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <QuestionAndAnswerGrid03SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFaqGrid03"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <QuestionAndAnswerGrid04SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFaqGrid04"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <QuestionAndAnswerGrid05SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFaqGrid05"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CollapsibleProductGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCollapsibleProductGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardVideoSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardVideoSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardVideoSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardVideo"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardViewmore
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardHaveViewMore"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardAccordions
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardAccordions"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardMediaWithSliderLosaprilySectionEditor
      v-if="
        viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMediaWithSliderLosaprily
      "
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardTabWithContentLosaprilySectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardTabWithContentLosaprily"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCedrowWithTabSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCedrowWithTab"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCedrowSideBySideSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCedrowSideBySide"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCedrowWithTabelSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCedrowWithTabel"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCedrowGridIconsSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCedrowGridIcons"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <LosaprilyCardBannerSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionLosaprilyCardBanner"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MarqueeTinoSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarqueeTino"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MarqueeImageSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarqueeImage"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MarqueeYuriSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarqueeYuri"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MarqueeShopzovyaSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarqueeShopzovya"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TabsBaseSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTabs"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardMediaSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMediaSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardMediaSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMediaSlider02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardMediaSliderSectionEditor03
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMediaSlider03"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardFeeSizeImgSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardFeeSizeImg"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TableKuboSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTableKubo"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewGridSectionEditor02
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewGrid02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ItemsGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionItemsGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ItemsGrid02SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionItemsGrid02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardStepInstructionsSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardStepInstructions"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <PurchaseIncentiveSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionPurchaseIncentive"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SocialMediaSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSocialMedia"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FeaturedOfferSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFeaturedOffer"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <PostSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionPost"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardReviewSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardReview"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardStepSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardStep"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TableBenefitsComparisonSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTableBenefitsComparison"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <BannerB1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBannerB1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ItemsSlideB1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionItemsSlideB1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardBasicB1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardBasicB1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCompareB1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCompareB1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <BannerBasicB1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBannerBasicB1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TableSmallB1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTableSmallB1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <IconWithTextB1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionIconWithTextB1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ImageWithTextBasicSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionImageWithTextBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SocialCommentEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSocialComment"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardFeatureSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardFeature"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardReviewSectionEditor02
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardReview02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardMediaSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMedia"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardKeyFeaturesSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardKeyFeatures"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewGridSectionEditor03
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewGridSection03"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <QuestionAndAnswerCardSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFaqCard"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <BannerMediaSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBannerMedia"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <GatorzYoutubeSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGatorzYoutube"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <GatorzCompareImageSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGatorzCompareImage"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <GatorzSupportSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGatorzSupport"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <GatorzFrameSpecsSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGatorzFrameSpecs"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <GatorzPolicySectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGatorzPolicy"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SaintbrandInfiniteMarqueeSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSaintbrandInfiniteMarquee"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardMultiToolSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMultiTool"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardMultiToolYuriSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMultiToolYuri"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardMultiToolDoubleSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMultiToolDouble"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TplaSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTpla"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewTitanSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewTitan"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewVitalSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewVital"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TextWithButtonSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTextWithButton"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FaqVitalSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFaqVital"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardVitalSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardVitalSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardVitalSlider02SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardVitalSlider02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardVitalSurroundSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardVitalSurround"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardVitalTabSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardVitalTab"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCompareProductSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCompareProduct"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MarkqueueRowsSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarkqueueRows"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FbPost03SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFbPost03"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ItemsGrid03SectionEditor
      v-if="
        (viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionItemsGrid03) ||
          viewSectionEditor.section.type === sectionType.sectionItemsGrid06
      "
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ItemsGrid04SectionEditor
      v-if="
        (viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionItemsGrid04) ||
          viewSectionEditor.section.type === sectionType.sectionItemsGrid05
      "
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewGridSectionEditor04
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewGrid04"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ReviewGridSectionEditor05
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionReviewGrid05"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardBasicSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ItemsGridMediaSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionItemsGridMedia"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardStepInstructions02SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardStepInstructions02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <BannerBasicSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBannerBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <BannerFastvaluedealSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBannerFastvaluedeal"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardBannerRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardBannerRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardBannerSowhatbuySectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardBannerSowhatbuy"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardItemsSowhatbuySectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardItemsSowhatbuy"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardCompareSowhatbuySectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCompareSowhatbuy"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardBanner02RivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardBanner02Rivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardSatelliteRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardSatelliteRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardWithSliderRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardWithSliderRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardGridItemRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardGridItemRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardSliderRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardSliderRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MarqueeRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarqueeRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardBasicRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardBasicRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardBadgeRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardBadgeRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardFaqRivoneedSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardFaqRivoneed"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ImageWithTextCol1SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionImageWithTextCol1"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SideBySideGridIconSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSideBySideGridIcon"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardBannerGatorzSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardBannerGatorz"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardGatorzCustomSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardGatorzCustom"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardGatorzGridItemSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardGatorzGridItem"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CardFastvaluedealTitleImgSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardFastvaluedealTitleImg"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SliderFastvaluedeal01SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSliderFastvaluedeal01"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FreestyleInfoSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFreestyleInfo"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <QuestionAndAnswerGrid06SectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFaqGrid06"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SectionMoneyBackGuaranteeEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMoneyBackGuarantee"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealCountdownSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealCountdown"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealFaqSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealFaq"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealMoneyBackGuaranteeSectionEditor
      v-if="
        viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealMoneyBackGuarantee
      "
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealReviewerSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealReviewer"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealCtaSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealCta"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealCardBasicSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealCardBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealCardStepSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealCardStep"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealCompareBenefitsSectionEditor
      v-if="
        viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealCompareBenefits
      "
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FastvaluedealTableSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFastvaluedealTable"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <MarkqueueOrthopedicSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarkqueueOrthopedic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <OrthopedicFeaturesGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionOrthopedicFeaturesGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <OrthopedicCardFeaturesSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionOrthopedicCardFeatures"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <OrthopedicCardReviewSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionOrthopedicCardReview"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <OrthopedicCardBasicSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionOrthopedicCardBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <LosaprilyImagesGridSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionLosaprilyImagesGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SowhatbuyCardBasicSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSowhatbuyCardBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SowhatbuyGuaranteeMarqueeSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSowhatbuyGuaranteeMarquee"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SowhatbuyFeaturesSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSowhatbuyFeaturesSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SowhatbuyRewardSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSowhatbuyReward"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SowhatbuyCardImageSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSowhatbuyCardImage"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TryherTimeline
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTryherTimeline"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TryherReviewGrid
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTryherReviewGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TryherGridPercent
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTryherGridPercent"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TryherCardCompare
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTryherCardCompare"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <TryherCardBasic
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTryherCardBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <CedrowFreetypeContentSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCedrowFreetypeContent"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <UpairyTabsSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionUpairyTabs"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <UpairyTimelineSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionUpairyTimeline"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <UpairyCardSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionUpairyCard"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <UpairyCompareCardSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionUpairyCompareCard"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <KonfortifyFbSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionKonfortifyFb"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <KonfortifyCardBasic
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionKonfortifyCardBasic"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <KonfortifyBanner
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionKonfortifyBanner"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <KonfortifyReviewGrid
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionKonfortifyReviewGrid"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopBanner
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopBanner"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopCardStep
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopCardStep"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopGridSlider
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopGridSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopGridSlider02
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopGridSlider02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopCarousel
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopCarousel"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopSpecification
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopSpecification"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopReward
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopReward"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopBanner02
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopBanner02"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopBanner03
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopBanner03"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FeetscareListImageSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFeetscareListImage"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FeetscareListItemSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFeetscareListItem"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FeetscareStatSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFeetscareStat"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FeetscareSatelliteSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFeetscareSatellite"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <FurnitureshopFaq
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFurnitureshopFaq"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ManchestoreCompareSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionManchestoreCompareSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ManchestoreBannerSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionManchestoreBanner"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ManchestoreCompareSliderSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionManchestoreCompareSlider"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <ManchestoreBannerSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionManchestoreBanner"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SofyreTabsReviewSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSofyreTabsReview"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SofyreTimelineSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSofyreTimeline"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SofyreIngredientsSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSofyreIngredients"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SofyreUserManualSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSofyreUserManual"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
    <SofyreComparisonSectionEditor
      v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSofyreComparison"
      :sectionEditor="viewSectionEditor"
      @close="handleCloseSectionEditor"
      @update:section="handleUpdateSection"
    />
  </div>
</template>

<script>
import { descriptionjs } from './main';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { extractDataAttributesFromHTML } from './common/html/extract';
import { cloneDeepObject } from './common/utils';
import { sectionType } from './common/types';
import SelectSectionTemplate from './modal-sections/select-section-template.vue';
import ViewSectionTemplate from './modal-sections/view-section.vue';
import CustomizeCard from './section-editor/customize-card.vue';
import FreestyleSectionEditor from './section-editor/freestyle.vue';
import ProductGridSectionEditor from './section-editor/product-grid.vue';
import SatelliteGridSectionEditor from './section-editor/satellite-grid.vue';
import QuestionFaqSectionEditor from './section-editor/question-faq.vue';
import IconWithTextSectionEditor from './section-editor/icon-with-text.vue';
import CardWithSurvey from './section-editor/card-with-survey.vue';
import CardDualImageSectionEditor from './section-editor/card-dual-image.vue';
import FindAnswerSectionEditor from './section-editor/find-answer.vue';
import TextCarouselSectionEditor from './section-editor/text-carousel.vue';
import ReviewGridSectionEditor from './section-editor/review-grid.vue';
import HeadingSectionEditor from './section-editor/heading-section.vue';
import CardSmokingSectionEditor from './section-editor/card-smoking.vue';
import ReviewGridKindLokalSectionEditor from './section-editor/review-grid-kind-lokal.vue';
import MarqueeWithTextSectionEditor from './section-editor/marquee-with-text.vue';
import CardWithSurveyTextSectionEditor from './section-editor/card-with-survey-text.vue';
import CardCompareTwoImageSectionEditor from './section-editor/card-compare-two-image.vue';
import CardCompareYuriSectionEditor from './section-editor/card-compare-yuri.vue';
import CardTimelineYuriSectionEditor from './section-editor/card-timeline-yuri.vue';
import CardSliderYuriSectionEditor from './section-editor/card-slider-yuri.vue';
import ReviewSliderYuriSectionEditor from './section-editor/review-slider-yuri.vue';
import CardStatisticsYuriSectionEditor from './section-editor/card-statistics-yuri.vue';
import CardWithTableCompareSectionEditor from './section-editor/card-with-table-compare.vue';
import BannerSliderSectionEditor from './section-editor/banner-slider.vue';
import IconWithTextSliderSectionEditor from './section-editor/icon-with-text-slider.vue';
import ProductReviewsSectionEditor from './section-editor/product-reviews/index.vue';
import SubscribeEmailSectionEditor from './section-editor/subscribe-email.vue';
import CardSonaSectionEditor from './section-editor/card-sona.vue';
import TinoGridSectionEditor from './section-editor/tino-grid.vue';
import ReviewInfiniteMarqueeSectionEditor from './section-editor/review-infinite-marquee.vue';
import QuestionAndAnswerGridSectionEditor from './section-editor/question-and-answer-grid.vue';
import QuestionAndAnswerGrid02SectionEditor from './section-editor/question-and-answer-grid-02.vue';
import QuestionAndAnswerGrid03SectionEditor from './section-editor/question-and-answer-grid-03.vue';
import CollapsibleProductGridSectionEditor from './section-editor/collapsible-product-grid.vue';
import CardVideoSliderSectionEditor from './section-editor/card-video-slider.vue';
import CardVideoSectionEditor from './section-editor/card-video.vue';
import CardViewmore from './section-editor/card-viewmore.vue';
import CardAccordions from './section-editor/card-accordions.vue';
import CardMediaWithSliderLosaprilySectionEditor from './section-editor/card-media-with-slider-losaprily.vue';
import CardTabWithContentLosaprilySectionEditor from './section-editor/card-tab-with-content-losaprily.vue';
import CardCedrowWithTabSectionEditor from './section-editor/card-cedrow-with-tab.vue';
import CardCedrowSideBySideSectionEditor from './section-editor/card-cedrow-side-by-side.vue';
import CardCedrowWithTabelSectionEditor from './section-editor/card-cedrow-with-tabel.vue';
import CardCedrowGridIconsSectionEditor from './section-editor/card-cedrow-grid-icons.vue';
import LosaprilyCardBannerSectionEditor from './section-editor/losaprily-card-banner.vue';
import MarqueeTinoSectionEditor from './section-editor/marquee-tino.vue';
import MarqueeImageSectionEditor from './section-editor/marquee-image.vue';
import MarqueeYuriSectionEditor from './section-editor/marquee-yuri.vue';
import MarqueeShopzovyaSectionEditor from './section-editor/marquee-shopzovya.vue';
import TabsBaseSectionEditor from './section-editor/tabs-base.vue';
import CardMediaSliderSectionEditor from './section-editor/card-media-slider.vue';
import CardFeeSizeImgSectionEditor from './section-editor/card-freesize-img.vue';
import TableKuboSectionEditor from './section-editor/table-kubo.vue';
import ItemsGridSectionEditor from './section-editor/items-grid.vue';
import ItemsGrid02SectionEditor from './section-editor/items-grid-02.vue';
import ReviewGridSectionEditor02 from './section-editor/review-grid-02.vue';
import CardStepInstructionsSectionEditor from './section-editor/card-step-instructions.vue';
import PurchaseIncentiveSectionEditor from './section-editor/purchase-incentive.vue';
import SocialMediaSectionEditor from './section-editor/social-media.vue';
import FeaturedOfferSectionEditor from './section-editor/featured-offer.vue';
import PostSectionEditor from './section-editor/post.vue';
import CardReviewSectionEditor from './section-editor/card-review.vue';
import CardStepSectionEditor from './section-editor/card-step.vue';
import TableBenefitsComparisonSectionEditor from './section-editor/table-benefits-comparison.vue';
import BannerB1SectionEditor from './section-editor/banner-b1.vue';
import ItemsSlideB1SectionEditor from './section-editor/items-slide-b1.vue';
import CardBasicB1SectionEditor from './section-editor/card-basic-b1.vue';
import CardCompareB1SectionEditor from './section-editor/card-compare-b1.vue';
import BannerBasicB1SectionEditor from './section-editor/banner-basic-b1.vue';
import TableSmallB1SectionEditor from './section-editor/table-small-b1.vue';
import IconWithTextB1SectionEditor from './section-editor/icon-with-text-b1.vue';
import ImageWithTextBasicSectionEditor from './section-editor/image-with-text-basic.vue';
import SocialCommentEditor from './section-editor/social-comment.vue';
import CardFeatureSectionEditor from './section-editor/card-feature.vue';
import CardMediaSliderSectionEditor03 from './section-editor/card-media-slider-03.vue';
import CardReviewSectionEditor02 from './section-editor/card-review-02.vue';
import CardMediaSectionEditor from './section-editor/card-media.vue';
import CardKeyFeaturesSectionEditor from './section-editor/card-key-features.vue';
import ReviewGridSectionEditor03 from './section-editor/review-grid-03.vue';
import QuestionAndAnswerCardSectionEditor from './section-editor/question-and-answer-card.vue';
import BannerMediaSectionEditor from './section-editor/banner-media.vue';
import GatorzYoutubeSectionEditor from './section-editor/gatorz-youtube.vue';
import GatorzCompareImageSectionEditor from './section-editor/gatorz-compare-image.vue';
import GatorzSupportSectionEditor from './section-editor/gatorz-support.vue';
import GatorzFrameSpecsSectionEditor from './section-editor/gatorz-frame-specs.vue';
import GatorzPolicySectionEditor from './section-editor/gatorz-policy.vue';
import SaintbrandInfiniteMarqueeSectionEditor from './section-editor/saintbrand-infinite-marquee.vue';
import QuestionAndAnswerGrid04SectionEditor from './section-editor/question-and-answer-grid-04.vue';
import CardMultiToolSectionEditor from './section-editor/card-multi-tool.vue';
import CardMultiToolYuriSectionEditor from './section-editor/card-multi-tool-yuri.vue';
import CardMultiToolDoubleSectionEditor from './section-editor/card-multi-tool-double.vue';
import TplaSectionEditor from './section-editor/tpla.vue';
import ReviewTitanSectionEditor from './section-editor/review-titan.vue';
import ReviewVitalSectionEditor from './section-editor/review-vital.vue';
import TextWithButtonSectionEditor from './section-editor/text-with-button.vue';
import FaqVitalSectionEditor from './section-editor/faq-vital.vue';
import CardVitalSliderSectionEditor from './section-editor/card-vital-slider.vue';
import CardVitalSlider02SectionEditor from './section-editor/card-vital-slider-02.vue';
import CardVitalSurroundSectionEditor from './section-editor/card-vital-surround.vue';
import CardVitalTabSectionEditor from './section-editor/card-vital-tab.vue';
import CardCompareProductSectionEditor from './section-editor/card-compare-product.vue';
import MarkqueueRowsSectionEditor from './section-editor/markqueue-rows.vue';
import FbPost03SectionEditor from './section-editor/fb-post-03.vue';
import QuestionAndAnswerGrid05SectionEditor from './section-editor/question-and-answer-grid-05.vue';
import ItemsGrid03SectionEditor from './section-editor/items-grid-03.vue';
import ItemsGrid04SectionEditor from './section-editor/items-grid-04.vue';
import ReviewGridSectionEditor04 from './section-editor/review-grid-04.vue';
import ReviewGridSectionEditor05 from './section-editor/review-grid-05.vue';
import TryherReviewGrid from './section-editor/tryher-review-grid.vue';
import TryherGridPercent from './section-editor/tryher-grid-percent.vue';
import TryherTimeline from './section-editor/tryher-timeline.vue';
import TryherCardCompare from './section-editor/tryher-card-compare.vue';
import TryherCardBasic from './section-editor/tryher-card-basic.vue';
import CardBasicSectionEditor from './section-editor/card-basic.vue';
import ItemsGridMediaSectionEditor from './section-editor/items-grid-media.vue';
import CardStepInstructions02SectionEditor from './section-editor/card-step-instructions-02.vue';
import BannerBasicSectionEditor from './section-editor/banner-basic.vue';
import BannerFastvaluedealSectionEditor from './section-editor/banner-fastvaluedeal.vue';
import CardBannerRivoneedSectionEditor from './section-editor/card-banner-rivoneed.vue';
import CardBannerSowhatbuySectionEditor from './section-editor/card-banner-sowhatbuy.vue';
import CardItemsSowhatbuySectionEditor from './section-editor/card-items-sowhatbuy.vue';
import CardCompareSowhatbuySectionEditor from './section-editor/card-compare-sowhatbuy.vue';
import CardBanner02RivoneedSectionEditor from './section-editor/card-banner-02-rivoneed.vue';
import CardSatelliteRivoneedSectionEditor from './section-editor/card-satellite-rivoneed.vue';
import CardWithSliderRivoneedSectionEditor from './section-editor/card-with-slider-rivoneed.vue';
import CardGridItemRivoneedSectionEditor from './section-editor/card-grid-item-rivoneed.vue';
import CardSliderRivoneedSectionEditor from './section-editor/card-slider-rivoneed.vue';
import MarqueeRivoneedSectionEditor from './section-editor/marquee-rivoneed.vue';
import CardBasicRivoneedSectionEditor from './section-editor/card-basic-rivoneed.vue';
import CardBadgeRivoneedSectionEditor from './section-editor/card-badge-rivoneed.vue';
import CardFaqRivoneedSectionEditor from './section-editor/card-faq-rivoneed.vue';
import ImageWithTextCol1SectionEditor from './section-editor/image-with-text-col-1.vue';
import SideBySideGridIconSectionEditor from './section-editor/side-by-side-grid-icon.vue';
import CardBannerGatorzSectionEditor from './section-editor/card-banner-gatorz.vue';
import CardGatorzCustomSectionEditor from './section-editor/card-gatorz-custom.vue';
import CardGatorzGridItemSectionEditor from './section-editor/card-gatorz-grid-item.vue';
import CardFastvaluedealTitleImgSectionEditor from './section-editor/card-fastvaluedeal-title-img.vue';
import SliderFastvaluedeal01SectionEditor from './section-editor/slider-fastvaluedeal-01.vue';
import FreestyleInfoSectionEditor from './section-editor/freestyle-info.vue';
import QuestionAndAnswerGrid06SectionEditor from './section-editor/question-and-answer-grid-06.vue';
import SectionMoneyBackGuaranteeEditor from './section-editor/section-money-back-guarantee.vue';
import FastvaluedealCountdownSectionEditor from './section-editor/fastvaluedeal-countdown.vue';
import FastvaluedealCtaSectionEditor from './section-editor/fastvaluedeal-cta.vue';
import FastvaluedealFaqSectionEditor from './section-editor/fastvaluedeal-faq.vue';
import FastvaluedealMoneyBackGuaranteeSectionEditor from './section-editor/fastvaluedeal-money-back-guarantee.vue';
import FastvaluedealReviewerSectionEditor from './section-editor/fastvaluedeal-reviewer.vue';
import FastvaluedealCardBasicSectionEditor from './section-editor/fastvaluedeal-card-basic.vue';
import FastvaluedealCardStepSectionEditor from './section-editor/fastvaluedeal-card-step.vue';
import FastvaluedealCompareBenefitsSectionEditor from './section-editor/fastvaluedeal-compare-benefits.vue';
import FastvaluedealTableSectionEditor from './section-editor/fastvaluedeal-table.vue';
import MarkqueueOrthopedicSectionEditor from './section-editor/markqueue-orthopedic.vue';
import OrthopedicFeaturesGridSectionEditor from './section-editor/orthopedic-features-grid.vue';
import OrthopedicCardFeaturesSectionEditor from './section-editor/orthopedic-card-features.vue';
import OrthopedicCardReviewSectionEditor from './section-editor/orthopedic-card-review.vue';
import OrthopedicCardBasicSectionEditor from './section-editor/orthopedic-card-basic.vue';
import LosaprilyImagesGridSectionEditor from './section-editor/losaprily-images-grid.vue';
import SowhatbuyCardBasicSectionEditor from './section-editor/sowhatbuy-card-basic.vue';
import SowhatbuyGuaranteeMarqueeSectionEditor from './section-editor/sowhatbuy-guarantee-marquee.vue';
import SowhatbuyFeaturesSliderSectionEditor from './section-editor/sowhatbuy-features-slider.vue';
import SowhatbuyRewardSectionEditor from './section-editor/sowhatbuy-reward.vue';
import SowhatbuyCardImageSectionEditor from './section-editor/sowhatbuy-card-image.vue';
import CedrowFreetypeContentSectionEditor from './section-editor/cedrow-section-freetype-content.vue';
import UpairyTabsSectionEditor from './section-editor/upairy-tabs.vue';
import UpairyTimelineSectionEditor from './section-editor/upairy-timeline.vue';
import KonfortifyReviewGrid from './section-editor/konfortify-review-grid.vue';
import FurnitureshopCardStep from './section-editor/furnitureshop-card-step.vue';
import UpairyCardSectionEditor from './section-editor/upairy-card.vue';
import UpairyCompareCardSectionEditor from './section-editor/upairy-compare-card.vue';
import KonfortifyFbSectionEditor from './section-editor/konfortify-fb.vue';
import KonfortifyCardBasic from './section-editor/konfortify-card-basic.vue';
// import CrawlData from './crawl-data/index.vue'
import KonfortifyBanner from './section-editor/konfortify-banner.vue';
import FurnitureshopBanner from './section-editor/furnitureshop-banner.vue';
import FurnitureshopGridSlider from './section-editor/furnitureshop-grid-slider.vue';
import FurnitureshopGridSlider02 from './section-editor/furnitureshop-grid-slider-02.vue';
import FurnitureshopSpecification from './section-editor/furnitureshop-specification.vue';
import FurnitureshopCarousel from './section-editor/furnitureshop-carousel.vue';
import FurnitureshopReward from './section-editor/furnitureshop-reward.vue';
import FurnitureshopBanner02 from './section-editor/furnitureshop-banner-02.vue';
import FurnitureshopBanner03 from './section-editor/furnitureshop-banner-03.vue';
import FurnitureshopFaq from './section-editor/furnitureshop-faq.vue';
import FeetscareListImageSectionEditor from './section-editor/feetscare-list-image.vue';
import FeetscareListItemSectionEditor from './section-editor/feetscare-list-item.vue';
import FeetscareStatSectionEditor from './section-editor/feetscare-stat.vue';
import FeetscareSatelliteSectionEditor from './section-editor/feetscare-satellite.vue';
import ManchestoreCompareSliderSectionEditor from './section-editor/manchestore-compare-slider.vue';
import ManchestoreBannerSectionEditor from './section-editor/manchestore-banner.vue';
import SofyreTabsReviewSectionEditor from './section-editor/sofyre-tabs-review.vue';
import SofyreTimelineSectionEditor from './section-editor/sofyre-timeline.vue';
import SofyreIngredientsSectionEditor from './section-editor/sofyre-ingredients.vue';
import SofyreUserManualSectionEditor from './section-editor/sofyre-user-manual.vue';
import SofyreComparisonSectionEditor from './section-editor/sofyre-comparison.vue';

import {
  deleteSection,
  insertSections,
  loadSectionsFromHtml,
  regenerateSectionIds,
  resolveSectionInsertIndex,
} from './common/insert-section.js';

export default {
  name: 'Description',
  components: {
    // CrawlData,
    SelectSectionTemplate,
    ViewSectionTemplate,
    CustomizeCard,
    FreestyleSectionEditor,
    ProductGridSectionEditor,
    SatelliteGridSectionEditor,
    QuestionFaqSectionEditor,
    IconWithTextSectionEditor,
    CardWithSurvey,
    CardDualImageSectionEditor,
    FindAnswerSectionEditor,
    TextCarouselSectionEditor,
    ReviewGridSectionEditor,
    ProductReviewsSectionEditor,
    HeadingSectionEditor,
    CardSmokingSectionEditor,
    ReviewGridKindLokalSectionEditor,
    MarqueeWithTextSectionEditor,
    CardWithSurveyTextSectionEditor,
    CardCompareTwoImageSectionEditor,
    CardCompareYuriSectionEditor,
    CardTimelineYuriSectionEditor,
    CardSliderYuriSectionEditor,
    ReviewSliderYuriSectionEditor,
    CardStatisticsYuriSectionEditor,
    CardWithTableCompareSectionEditor,
    BannerSliderSectionEditor,
    IconWithTextSliderSectionEditor,
    SubscribeEmailSectionEditor,
    CardSonaSectionEditor,
    TinoGridSectionEditor,
    ReviewInfiniteMarqueeSectionEditor,
    QuestionAndAnswerGridSectionEditor,
    QuestionAndAnswerGrid02SectionEditor,
    QuestionAndAnswerGrid03SectionEditor,
    CollapsibleProductGridSectionEditor,
    CardVideoSliderSectionEditor,
    CardVideoSectionEditor,
    CardViewmore,
    CardAccordions,
    CardMediaWithSliderLosaprilySectionEditor,
    CardTabWithContentLosaprilySectionEditor,
    CardCedrowWithTabSectionEditor,
    CardCedrowSideBySideSectionEditor,
    CardCedrowWithTabelSectionEditor,
    CardCedrowGridIconsSectionEditor,
    LosaprilyCardBannerSectionEditor,
    MarqueeTinoSectionEditor,
    MarqueeImageSectionEditor,
    MarqueeYuriSectionEditor,
    MarqueeShopzovyaSectionEditor,
    TabsBaseSectionEditor,
    CardMediaSliderSectionEditor,
    CardFeeSizeImgSectionEditor,
    TableKuboSectionEditor,
    ReviewGridSectionEditor02,
    ItemsGridSectionEditor,
    ItemsGrid02SectionEditor,
    CardStepInstructionsSectionEditor,
    PurchaseIncentiveSectionEditor,
    SocialMediaSectionEditor,
    FeaturedOfferSectionEditor,
    PostSectionEditor,
    CardReviewSectionEditor,
    CardStepSectionEditor,
    TableBenefitsComparisonSectionEditor,
    BannerB1SectionEditor,
    ItemsSlideB1SectionEditor,
    CardBasicB1SectionEditor,
    CardCompareB1SectionEditor,
    BannerBasicB1SectionEditor,
    TableSmallB1SectionEditor,
    IconWithTextB1SectionEditor,
    ImageWithTextBasicSectionEditor,
    SocialCommentEditor,
    CardFeatureSectionEditor,
    CardMediaSliderSectionEditor03,
    CardReviewSectionEditor02,
    CardMediaSectionEditor,
    CardKeyFeaturesSectionEditor,
    ReviewGridSectionEditor03,
    QuestionAndAnswerCardSectionEditor,
    BannerMediaSectionEditor,
    GatorzYoutubeSectionEditor,
    GatorzCompareImageSectionEditor,
    GatorzSupportSectionEditor,
    GatorzFrameSpecsSectionEditor,
    QuestionAndAnswerGrid04SectionEditor,
    CardMultiToolSectionEditor,
    CardMultiToolYuriSectionEditor,
    CardMultiToolDoubleSectionEditor,
    TplaSectionEditor,
    ReviewTitanSectionEditor,
    ReviewVitalSectionEditor,
    TextWithButtonSectionEditor,
    FaqVitalSectionEditor,
    CardVitalSliderSectionEditor,
    CardVitalSlider02SectionEditor,
    CardVitalSurroundSectionEditor,
    CardVitalTabSectionEditor,
    CardCompareProductSectionEditor,
    MarkqueueRowsSectionEditor,
    FbPost03SectionEditor,
    QuestionAndAnswerGrid05SectionEditor,
    ItemsGrid03SectionEditor,
    ItemsGrid04SectionEditor,
    ReviewGridSectionEditor04,
    ReviewGridSectionEditor05,
    CardBasicSectionEditor,
    ItemsGridMediaSectionEditor,
    CardStepInstructions02SectionEditor,
    BannerBasicSectionEditor,
    BannerFastvaluedealSectionEditor,
    CardBannerRivoneedSectionEditor,
    CardBannerSowhatbuySectionEditor,
    CardItemsSowhatbuySectionEditor,
    CardCompareSowhatbuySectionEditor,
    CardBanner02RivoneedSectionEditor,
    CardSatelliteRivoneedSectionEditor,
    CardWithSliderRivoneedSectionEditor,
    CardGridItemRivoneedSectionEditor,
    CardSliderRivoneedSectionEditor,
    MarqueeRivoneedSectionEditor,
    CardBasicRivoneedSectionEditor,
    CardBadgeRivoneedSectionEditor,
    CardFaqRivoneedSectionEditor,
    ImageWithTextCol1SectionEditor,
    SideBySideGridIconSectionEditor,
    CardBannerGatorzSectionEditor,
    CardGatorzCustomSectionEditor,
    CardGatorzGridItemSectionEditor,
    CardFastvaluedealTitleImgSectionEditor,
    SliderFastvaluedeal01SectionEditor,
    FreestyleInfoSectionEditor,
    QuestionAndAnswerGrid06SectionEditor,
    SectionMoneyBackGuaranteeEditor,
    FastvaluedealCountdownSectionEditor,
    FastvaluedealCtaSectionEditor,
    FastvaluedealFaqSectionEditor,
    FastvaluedealMoneyBackGuaranteeSectionEditor,
    FastvaluedealReviewerSectionEditor,
    FastvaluedealCardBasicSectionEditor,
    FastvaluedealCardStepSectionEditor,
    FastvaluedealCompareBenefitsSectionEditor,
    FastvaluedealTableSectionEditor,
    GatorzPolicySectionEditor,
    SaintbrandInfiniteMarqueeSectionEditor,
    MarkqueueOrthopedicSectionEditor,
    OrthopedicFeaturesGridSectionEditor,
    OrthopedicCardFeaturesSectionEditor,
    OrthopedicCardReviewSectionEditor,
    OrthopedicCardBasicSectionEditor,
    LosaprilyImagesGridSectionEditor,
    SowhatbuyCardBasicSectionEditor,
    SowhatbuyGuaranteeMarqueeSectionEditor,
    SowhatbuyFeaturesSliderSectionEditor,
    SowhatbuyRewardSectionEditor,
    SowhatbuyCardImageSectionEditor,
    CedrowFreetypeContentSectionEditor,
    TryherReviewGrid,
    TryherGridPercent,
    TryherTimeline,
    TryherCardCompare,
    TryherCardBasic,
    KonfortifyReviewGrid,
    UpairyTabsSectionEditor,
    UpairyTimelineSectionEditor,
    UpairyCardSectionEditor,
    UpairyCompareCardSectionEditor,
    KonfortifyFbSectionEditor,
    KonfortifyCardBasic,
    KonfortifyBanner,
    FurnitureshopBanner,
    FurnitureshopCardStep,
    FurnitureshopGridSlider,
    FurnitureshopGridSlider02,
    FurnitureshopSpecification,
    FurnitureshopCarousel,
    FurnitureshopReward,
    FurnitureshopBanner02,
    FurnitureshopBanner03,
    FurnitureshopFaq,
    FeetscareListImageSectionEditor,
    FeetscareListItemSectionEditor,
    FeetscareStatSectionEditor,
    FeetscareSatelliteSectionEditor,
    ManchestoreCompareSliderSectionEditor,
    ManchestoreBannerSectionEditor,
    SofyreTabsReviewSectionEditor,
    SofyreTimelineSectionEditor,
    SofyreIngredientsSectionEditor,
    SofyreUserManualSectionEditor,
    SofyreComparisonSectionEditor,
  },
  props: {
    model: {
      type: String,
      default: 'bodyHtml',
    },
    catalog: {
      type: Object,
      required: true,
    },
    catalogCreation: {
      type: Boolean,
      default: false,
    },
    sectionsPanel: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      createDescriptionBy: 'template',
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      indexInsertNewSection: -1,
      sectionType,
      sections: [],
      showSectionTemplateModal: false,
      snackbar: false,
      snackbarMessage: '',
      snackbarColor: 'success',
      viewExpandSection: {
        showViewSection: false,
        section: {},
      },
      viewSectionEditor: {
        show: false,
        sectionExtract: {},
        section: {},
      },
    };
  },
  methods: {
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        const elementPosition = element.offsetTop + 132;

        window.scrollTo({
          top: elementPosition,
          behavior: 'smooth',
        });
        element.classList.add('active-section');
        setTimeout(() => {
          element.classList.remove('active-section');
        }, 3000);
      }
    },
    handleViewSection(section) {
      const uniqueId = Math.random()
        .toString(36)
        .slice(2, 8);
      // anh e sau có maintain thì chú ý cái prefix là prl nhé, nó được set trong lúc chọn template
      const regex = new RegExp(`prl-[a-z0-9]{6}`, 'g');

      this.viewExpandSection.showViewSection = true;

      this.viewExpandSection.section = {
        ...section,
        html: section.html.replace(regex, uniqueId),
      };
    },
    handleViewSectionEditor(section) {
      switch (section.type) {
        case sectionType.sectionCustomizeCard: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCustomizeCard(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardWithSurvey: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardWithSurvey(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFreestyle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFreestyle(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionProductGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionProductGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSatelliteGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSatelliteGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionQuestionFaq: {
          const sectionExtract = extractDataAttributesFromHTML.sectionQuestionFaq(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionIconWithText: {
          const sectionExtract = extractDataAttributesFromHTML.sectionIconWithText(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardDualImg: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardDualImg(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFindAnswer: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFindAnswer(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTextCarousel: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTextCarousel(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionHeading: {
          const sectionExtract = extractDataAttributesFromHTML.sectionHeading(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardSmoking: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardSmoking(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewGrid02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewGrid02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionProductReviews:
        case sectionType.sectionProductReviews02:
        case sectionType.sectionProductReviews03:
        case sectionType.sectionProductReviews04:
        case sectionType.sectionProductReviews05:
        case sectionType.sectionProductReviews06:
        case sectionType.sectionGatorzReviews:
        case sectionType.sectionFastvaluedealReviews:
        case sectionType.sectionSaintbrandReviews:
        case sectionType.sectionLosaprilyReviews: {
          const sectionExtract = extractDataAttributesFromHTML.sectionProductReviews(section.html, section.type);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewGridKindLokal: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewGridKindLokal(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarqueeBasicText: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarqueeBasicText(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTextSurvey: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTextSurvey(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCompareTwoImg: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCompareTwoImg(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCompareYuri: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCompareYuri(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardTimelineYuri: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardTimelineYuri(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardSliderYuri: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardSliderYuri(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewSliderYuri: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewSliderYuri(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardStatisticsYuri: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardStatisticsYuri(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardWithTableCompare: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardWithTableCompare(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBannerSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionIconWitTextSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionIconWithTextSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSubscribeEmail: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSubscribeEmail(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardSona: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardSona(section.html);

          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTinoGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTinoGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewInfiniteMarquee: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewInfiniteMarquee(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFaqGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFaqGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCollapsibleProductGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCollapsibleProductGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardVideoSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardVideoSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardVideo: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardVideo(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardHaveViewMore: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCustomizeCard(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardAccordions: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardAccordions(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMediaWithSliderLosaprily: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMediaWithSliderLosaprily(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardTabWithContentLosaprily: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardTabWithContentLosaprily(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCedrowWithTab: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCedrowWithTab(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCedrowSideBySide: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCedrowSideBySide(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCedrowWithTabel: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCedrowWithTabel(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCedrowGridIcons: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCedrowGridIcons(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionLosaprilyCardBanner: {
          const sectionExtract = extractDataAttributesFromHTML.sectionLosaprilyCardBanner(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarqueeTino: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarqueeTino(section.html);

          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarqueeImage: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarqueeImage(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarqueeYuri: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarqueeYuri(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarqueeShopzovya: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarqueeShopzovya(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTabs: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTabs(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMediaSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMediaSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMediaSlider02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMediaSlider(section.html, section.type);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMediaSlider03: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMediaSlider03(section.html, section.type);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardFeeSizeImg: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardFeeSizeImg(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTableKubo: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTableKubo(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionItemsGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionItemsGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionItemsGrid02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionItemsGrid02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardStepInstructions: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardStepInstructions(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionPurchaseIncentive: {
          const sectionExtract = extractDataAttributesFromHTML.sectionPurchaseIncentive(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSocialMedia: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSocialMedia(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFeaturedOffer: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFeaturedOffer(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionPost: {
          const sectionExtract = extractDataAttributesFromHTML.sectionPost(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardReview: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardReview(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardStep: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardStep(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTableBenefitsComparison: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTableBenefitsComparison(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBannerB1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerB1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionItemsSlideB1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionItemsSlideB1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardBasicB1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardBasicB1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCompareB1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCompareB1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBannerBasicB1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerBasicB1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTableSmallB1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTableSmallB1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionIconWithTextB1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionIconWithTextB1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionImageWithTextBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionImageWithTextBasic(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSocialComment: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSocialComment(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFaqGrid02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFaqGrid02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFaqGrid03: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFaqGrid03(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFaqGrid04: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFaqGrid04(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFaqCard: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFaqCard(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardFeature: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardFeature(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardReview02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardReview02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMedia: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMedia(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardKeyFeatures: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardKeyFeatures(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewGridSection03: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewGridSection03(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBannerMedia: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerMedia(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGatorzYoutube: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGatorzYoutube(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGatorzCompareImage: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGatorzCompareImage(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGatorzSupport: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGatorzSupport(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGatorzFrameSpecs: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGatorzFrameSpecs(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGatorzPolicy: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGatorzPolicy(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSaintbrandInfiniteMarquee: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSaintbrandInfiniteMarquee(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMultiTool: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMultiTool(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMultiToolYuri: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMultiToolYuri(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMultiToolDouble: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMultiToolDouble(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTpla: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTpla(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewTitan: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewTitan(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewVital: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewVital(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTextWithButton: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTextWithButton(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFaqVital: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFaqVital(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardVitalSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardVitalSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardVitalSlider02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardVitalSlider02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardVitalSurround: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardVitalSurround(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardVitalTab: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardVitalTab(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCompareProduct: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCompareProduct(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarkqueueRows: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarkqueueRows(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFbPost03: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFbPost03(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFaqGrid05: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFaqGrid05(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionItemsGrid03: {
          const sectionExtract = extractDataAttributesFromHTML.sectionItemsGrid03(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionItemsGrid04: {
          const sectionExtract = extractDataAttributesFromHTML.sectionItemsGrid04(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionItemsGrid05: {
          const sectionExtract = extractDataAttributesFromHTML.sectionItemsGrid04(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewGrid04: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewGrid04(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionReviewGrid05: {
          const sectionExtract = extractDataAttributesFromHTML.sectionReviewGrid05(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionItemsGrid06: {
          const sectionExtract = extractDataAttributesFromHTML.sectionItemsGrid03(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardBasic(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionItemsGridMedia: {
          const sectionExtract = extractDataAttributesFromHTML.sectionItemsGridMedia(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardStepInstructions02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardStepInstructions02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBannerBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerBasic(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBannerFastvaluedeal: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerFastvaluedeal(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardBannerRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardBannerRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardBannerSowhatbuy: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardBannerSowhatbuy(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardItemsSowhatbuy: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardItemsSowhatbuy(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCompareSowhatbuy: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCompareSowhatbuy(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardBanner02Rivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardBanner02Rivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardSatelliteRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardSatelliteRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardWithSliderRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardWithSliderRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardGridItemRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardGridItemRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardSliderRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardSliderRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarqueeRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarqueeRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardBasicRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardBasicRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardBadgeRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardBadgeRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardFaqRivoneed: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardFaqRivoneed(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionImageWithTextCol1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionImageWithTextCol1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSideBySideGridIcon: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSideBySideGridIcon(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardBannerGatorz: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardBannerGatorz(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardGatorzCustom: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardGatorzCustom(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardGatorzGridItem: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardGatorzGridItem(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardFastvaluedealTitleImg: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardFastvaluedealTitleImg(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSliderFastvaluedeal01: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSliderFastvaluedeal01(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFreestyleInfo: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFreestyleInfo(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFaqGrid06: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFaqGrid06(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMoneyBackGuarantee: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMoneyBackGuarantee(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealCountdown: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealCountdown(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealCta: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealCta(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealFaq: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealFaq(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealMoneyBackGuarantee: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealMoneyBackGuarantee(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealReviewer: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealReviewer(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealCardBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealCardBasic(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealCardStep: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealCardStep(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealCompareBenefits: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealCompareBenefits(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionFastvaluedealTable: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFastvaluedealTable(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarkqueueOrthopedic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarkqueueOrthopedic(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionOrthopedicFeaturesGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionOrthopedicFeaturesGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionOrthopedicCardFeatures: {
          const sectionExtract = extractDataAttributesFromHTML.sectionOrthopedicCardFeatures(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionOrthopedicCardReview: {
          const sectionExtract = extractDataAttributesFromHTML.sectionOrthopedicCardReview(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionOrthopedicCardBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionOrthopedicCardBasic(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionLosaprilyImagesGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionLosaprilyImagesGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSowhatbuyCardBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSowhatbuyCardBasic(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSowhatbuyGuaranteeMarquee: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSowhatbuyGuaranteeMarquee(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSowhatbuyFeaturesSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSowhatbuyFeatureSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSowhatbuyReward: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSowhatbuyReward(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSowhatbuyCardImage: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSowhatbuyCardImage(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTryherTimeline: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTryherTimeline(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTryherReviewGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTryherReviewGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTryherCardCompare: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTryherCardCompare(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionTryherGridPercent: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTryherGridPercent(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionTryherCardBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTryherCardBasic(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionCedrowFreetypeContent: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCedrowFreetypeContent(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionUpairyTabs: {
          const sectionExtract = extractDataAttributesFromHTML.sectionUpairyTabs(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionUpairyTimeline: {
          const sectionExtract = extractDataAttributesFromHTML.sectionUpairyTimeline(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionUpairyCard: {
          const sectionExtract = extractDataAttributesFromHTML.sectionUpairyCard(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionUpairyCompareCard: {
          const sectionExtract = extractDataAttributesFromHTML.sectionUpairyCompareCard(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionKonfortifyFb: {
          const sectionExtract = extractDataAttributesFromHTML.sectionKonfortifyFb(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionKonfortifyCardBasic: {
          const sectionExtract = extractDataAttributesFromHTML.sectionKonfortifyCardBasic(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionKonfortifyReviewGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionKonfortifyReviewGrid(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionKonfortifyBanner: {
          const sectionExtract = extractDataAttributesFromHTML.sectionKonfortifyBanner(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopBanner: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopBanner(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopCardStep: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopCardStep(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopGridSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopGridSlider(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopGridSlider02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopGridSlider02(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopSpecification: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopSpecification(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopCarousel: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopCarousel(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopReward: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopReward(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopBanner02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopBanner02(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopBanner03: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopBanner03(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFurnitureshopFaq: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFurnitureshopFaq(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFeetscareListImage: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFeetscareListImage(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFeetscareListItem: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFeetscareListItem(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFeetscareStat: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFeetscareStat(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionFeetscareSatellite: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFeetscareSatellite(section.html);
          this.viewSectionEditor = { show: true, sectionExtract, section: section };
          break;
        }
        case sectionType.sectionManchestoreCompareSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionManchestoreCompareSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionManchestoreBanner: {
          const sectionExtract = extractDataAttributesFromHTML.sectionManchestoreBanner(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSofyreTabsReview: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSofyreTabsReview(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSofyreTimeline: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSofyreTimeline(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSofyreIngredients: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSofyreIngredients(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSofyreUserManual: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSofyreUserManual(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSofyreComparison: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSofyreComparison(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        default:
          break;
      }
    },
    handleCloseSectionEditor() {
      this.viewSectionEditor = {
        show: false,
        sectionExtract: {},
        section: {},
      };
    },
    handleUpdateSection(section) {
      this.sections = this.sections.map(item => (item.id === section.id ? section : item));
    },
    handleDeleteSection(section) {
      this.sections = deleteSection(this.sections, section);
    },
    handleInsertAllSections(templates) {
      this.sections = insertSections(this.sections, templates);
      this.showSectionTemplateModal = false;
    },
    handleRemoveAllSections() {
      if (window.confirm('Are you sure to remove all description sections?')) {
        this.sections = [];
      }
    },
    handleCloseSectionTemplateModal() {
      this.showSectionTemplateModal = false;
      this.indexInsertNewSection = -1;
    },
    handleShowPopupSelectSectionTemplate() {
      this.showSectionTemplateModal = true;
    },
    handleSectionTemplateSelect(template) {
      const atIndex = this.indexInsertNewSection >= 0 ? this.indexInsertNewSection : undefined;
      this.sections = insertSections(this.sections, template, { atIndex });
      this.showSectionTemplateModal = false;
      this.indexInsertNewSection = -1;
      setTimeout(() => {
        this.scrollToSection(template.id);
      }, 100);
    },
    handleInsertSections(sections) {
      const cloneSections = cloneDeepObject(sections);
      const convertSections = cloneSections.map(section => {
        return {
          id: section.id,
          html: section.html,
          title: section.title,
          type: section.type,
        };
      });
      this.sections = insertSections(this.sections, convertSections);
    },
    async handleCopySections() {
      const html = (this.sections || []).map(section => section.html).join('');
      if (!html) {
        this.$store.commit('setMessages', { messages: 'No sections to copy', type: 'warning' });
        return;
      }

      try {
        await navigator.clipboard.writeText(html);
        this.$store.commit('setMessages', { messages: 'Sections copied to clipboard', type: 'success' });
      } catch (err) {
        console.error('Failed to copy sections: ', err);
        this.$store.commit('setMessages', { messages: 'Failed to copy sections', type: 'error' });
      }
    },
    async handlePasteSections() {
      let clipboardText = '';
      try {
        clipboardText = await navigator.clipboard.readText();
      } catch (err) {
        console.error('Failed to read clipboard: ', err);
        this.$store.commit('setMessages', {
          messages: 'Unable to read clipboard. Please allow clipboard permission and try again.',
          type: 'error',
        });
        return;
      }

      if (!clipboardText?.trim()) {
        this.$store.commit('setMessages', { messages: 'Clipboard is empty', type: 'warning' });
        return;
      }

      const parsedSections = regenerateSectionIds(loadSectionsFromHtml(clipboardText));
      if (!parsedSections.length) {
        this.$store.commit('setMessages', { messages: 'No valid sections found in clipboard', type: 'warning' });
        return;
      }

      this.sections = insertSections(this.sections, parsedSections);
      this.$store.commit('setMessages', { messages: 'Sections pasted', type: 'success' });
    },
    handleMoveSection(section, direction) {
      const index = this.sections.findIndex(item => item.id === section.id);
      if (index === -1) return;
      const newSections = cloneDeepObject(this.sections);
      if (direction === 'up') {
        if (index === 0) return;
        newSections.splice(index, 1);
        newSections.splice(index - 1, 0, section);
      } else if (direction === 'down') {
        if (index === newSections.length - 1) return;
        newSections.splice(index, 1);
        newSections.splice(index + 1, 0, section);
      } else {
        return;
      }
      this.sections = newSections.map((item, index) => ({ ...item, position: index }));
      setTimeout(() => {
        this.scrollToSection(section.id);
      }, 100);
    },
    handleInsertNewSection(section, position) {
      const insertIndex = resolveSectionInsertIndex(this.sections, { section, position });
      if (insertIndex < 0) return;
      this.indexInsertNewSection = insertIndex;
      this.handleShowPopupSelectSectionTemplate();
    },
    handleSwitchCreateDescription() {
      this.createDescriptionBy = this.createDescriptionBy === 'editor' ? 'template' : 'editor';
      this.catalog[this.model] = '';
      this.sections = [];
    },
  },
  computed: {
    behaviorCreateDescription() {
      const objState = {};
      if (this.catalogCreation) {
        objState.nameActionSwitch = this.createDescriptionBy === 'editor' ? 'Use template' : 'Use editor';
        objState.showCkEditor = this.createDescriptionBy === 'editor';
        objState.showSwitchCreateDescription = true;
        objState.showPlaceholderAddNewSection =
          this.visibleSections.length === 0 && this.createDescriptionBy === 'template';
        objState.showSectionItem = this.createDescriptionBy === 'template';
      } else {
        objState.nameActionSwitch = '';
        objState.showCkEditor = false;
        objState.showSwitchCreateDescription = false;
        objState.showPlaceholderAddNewSection = this.visibleSections.length === 0;
        objState.showSectionItem = true;
      }

      return objState;
    },
    visibleSections() {
      return (this.sections || []).filter(s => !s?.hidden);
    },
  },
  mounted() {
    this.sections = loadSectionsFromHtml(this.catalog[this.model]);
    if (this.model === 'bodyHtml') {
      this.$root.$on('insert-all-desc-sections', this.handleInsertAllSections);
      this.$root.$on('remove-all-desc-sections', this.handleRemoveAllSections);
    }
  },
  beforeDestroy() {
    if (this.model === 'bodyHtml') {
      this.$root.$off('insert-all-desc-sections', this.handleInsertAllSections);
      this.$root.$off('remove-all-desc-sections', this.handleRemoveAllSections);
    }
  },
  watch: {
    catalog: {
      handler(newVal) {
        this.sections = loadSectionsFromHtml(newVal[this.model]);
      },
    },
    sections: {
      handler(newVal) {
        this.$emit(
          'update:sectionsPanel',
          (newVal || [])
            .filter(s => !s?.hidden)
            .map(section => ({
              title: section.title,
              id: section.id,
            })),
        );
        this.$emit('update:bodyHtmlDescription', newVal.map(section => section.html).join(''));

        this.$nextTick(() => {
          const container = this.$refs.descriptionContainer;
          if (!container) return;

          const scriptsSwiper = container.querySelector('script[data-attribute="script-swiper"]');

          if (scriptsSwiper) {
            const newScriptCDN = document.createElement('script');
            newScriptCDN.src = scriptsSwiper.getAttribute('src');
            newScriptCDN.setAttribute('data-ignore', 'true');

            newScriptCDN.onload = () => {
              runOtherScripts();
            };

            scriptsSwiper.parentNode.replaceChild(newScriptCDN, scriptsSwiper);
          } else {
            runOtherScripts();
          }

          function runOtherScripts() {
            const scripts = container.querySelectorAll('script:not([data-executed]):not([data-ignore])');
            scripts.forEach(script => {
              const newScript = document.createElement('script');
              for (const attr of script.attributes) newScript.setAttribute(attr.name, attr.value);
              newScript.text = script.textContent;
              // newScript.setAttribute('type', 'module')
              script.parentNode.replaceChild(newScript, script);
              newScript.setAttribute('data-executed', '1');
            });
          }
          descriptionjs();
        });
      },
      deep: true,
      // immediate: true,
    },
  },
};
</script>
